import { ReactNode, useEffect } from "react"
import RootLayout from "./Root"

const PublicLayout = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    document.body.classList.add("bg-gray-900")
  }, [])

  return (
    <RootLayout className="text-white bg-gray-900">
      <main className="flex-1">{children}</main>
    </RootLayout>
  )
}
export default PublicLayout
